// extracted by css-extract-rspack-plugin
export default {"columnFieldSet":"columnFieldSet-Hm5kkk","columnFieldSetHeading":"columnFieldSetHeading-bThhaM","reportHeading":"reportHeading-LKEZJL"};